import ApiBase from './Api'

const ISINS_API_PATHS = {
    ISIN_COUNT: (isin: string) => `/admin/isins/${isin}`,
    ISINS: '/admin/isins',
}

class IsinsApi extends ApiBase {
    async fetchIsinCount(isin: string, entityId: string | null) {
        const response = await this._getRequest(ISINS_API_PATHS.ISIN_COUNT(isin), { queryParameters: { entityId } })
        return response
    }

    async fetchUnusedIsins() {
        const response = await this._getRequest(ISINS_API_PATHS.ISINS, { queryParameters: { unused: true } })
        return response
    }

    async archiveIsin(isin: string) {
        if (!isin) {
            return
        }
        if (isin.length !== 12) {
            throw new Error(`Invalid ISIN ${JSON.stringify(isin, null, 2)}`)
        }
        const response = await this._postRequest(ISINS_API_PATHS.ISINS, { archived: true, isin })
        return response
    }
}

export default IsinsApi
